import { fetchAssignment as fetchAssignmentAPI } from "../api";

export const fetchAssignmentAction = async (
  assignmentID,
  setAssignment,
  setQuestion = null
) => {
  const assignmentObject = await fetchAssignmentAPI(assignmentID);
  setAssignment(assignmentObject.data);
  if (setQuestion) {
    setQuestion(assignmentObject.data.questions[0]);
  }
};

export const fetchAssignmentActionSimple = async (assignmentID) => {
  const assignmentObject = await fetchAssignmentAPI(assignmentID);
  return assignmentObject.data;
};
